import PropTypes from 'prop-types';
import React from 'react';

import { capitalizeFirstLetter } from 'common-src/utils/stringUtils';

import usePopup from 'src/hooks/usePopup';

import BasePopup from '../BasePopup';
import styles from './WarningPopup.module.scss';

const WarningPopup = ({
  onSubmit,
  onClose,
  message,
  type,
  title,
  content,
  showCancelButton = true,
  submitButtonText = 'Confirm',
}) => {
  const { renderButtons } = usePopup();

  return (
    <BasePopup
      id="request-status"
      onClose={onClose}
      open
      title={title || capitalizeFirstLetter(type)}
    >
      <div className={styles.wrapper}>
        <p className={[styles.message, 'font-w-500', 'font-s-16'].join(' ')}>{message}</p>
        {content && <div className="m-t-8">{content}</div>}
      </div>
      {renderButtons({
        containerClassName: styles.buttonsContainer,
        onClose: showCancelButton ? onClose : null,
        onSubmit,
        isSubmitEnabled: true,
        submitButtonText,
      })}
    </BasePopup>
  );
};

WarningPopup.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  message: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.element,
  submitButtonText: PropTypes.string,
  showCancelButton: PropTypes.bool,
};

export default WarningPopup;
